import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events/context';
import { DefaultBiEvent } from '@wix/da-bi/pkg/events/events';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import OriginalBrushGradient from '@wix/da-ds/pkg/Icons/24x24/OriginalBrushGradient';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './CreateOriginalCard.scss';

export const CreateOriginalCard: React.FC = () => {
  const { t } = useTranslation();
  return (
    <PlainButtonOrLink
      className={s['root']}
      href={Url.studio({ openCreateForm: true })}
      biData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'create_original',
        sectionname: BiContextProvidedValue,
      })}
    >
      <OriginalBrushGradient size={IconSize.MEDIUM} />
      <span className={s['text']}>
        {t('pages.shop.originals.createCard.label')}
      </span>
    </PlainButtonOrLink>
  );
};
CreateOriginalCard.displayName = 'CreateOriginalCard';

export default CreateOriginalCard;
